import { Loader as MantineLoader } from "@mantine/core";
import { loadertype } from "./mantineReactTable/MantineReactTableProps";

interface Props {
   height?:number;
   size?:string;
}
const AppLoader = ({height=60, size}:Props) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: `${height}vh`,
      }}
    >
      <MantineLoader color="indigo" size={size} type={loadertype} />
    </div>
  );
};

export default AppLoader;
